/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCosh } from '../../factoriesAny.js';
export var coshDependencies = {
  typedDependencies,
  createCosh
};